var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1OutdoorSiren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.07 54.89a19.81 19.81 0 01-5.6 13.81l-2.27-2a16.86 16.86 0 00-.2-23.83l2.19-2.06a19.86 19.86 0 015.88 14.08zM64.77 45l-2.19 2a10.77 10.77 0 010 15.72l2.29 2a13.79 13.79 0 00-.1-19.72zm-4.51 4.23L58 51.28a4.61 4.61 0 01-.17 7.37v.07l2.27 2a7.621 7.621 0 00.11-11.47l.05-.02zM4 25.43L29.78 9.29 55 25.42v17.25l4-3.41v-16L29.81 4.55 0 23.21V60h34v-4H4V25.43zm50.69 33.46c-.88-2.84-3.18-10.28-3.52-11.21a.268.268 0 010-.08 4 4 0 00-3.82-2.6H47a4 4 0 00-3.71 1.91C42.91 47.5 39 60 39 60h5.06v1.75A1.252 1.252 0 0045.34 63h3.5a1.25 1.25 0 001.25-1.25V60H55c0-.15-.14-.54-.31-1.11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Outdoor_siren.c0348881.svg";
export { SvgG1OutdoorSiren as ReactComponent };